import { render, staticRenderFns } from "./HomeSettings.vue?vue&type=template&id=38af7922&scoped=true&"
import script from "./HomeSettings.vue?vue&type=script&lang=js&"
export * from "./HomeSettings.vue?vue&type=script&lang=js&"
import style0 from "./HomeSettings.vue?vue&type=style&index=0&id=38af7922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af7922",
  null
  
)

export default component.exports